<template>
    <div>
        <md-card>
            <md-card-header>
                <div class="md-title">Comissões</div>
            </md-card-header>

            <md-card-content>
                <hr>
                <div class="row" v-for="(commission, k) of commissions" :key="k">
                    <div class="col-md-4">
                        <div class="form-group bmd-form-group is-filled">
                            <label for="profession" class="bmd-label-floating">Parcela</label>
                            <model-select :options="typesCommissions" v-model="commission.sequence" placeholder="Parcela da comissão"></model-select>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group bmd-form-group is-filled">
                            <label for="name" class="bmd-label-floating">Comissão (%)</label>
                            <money v-model="commission.commission" maxlength="6" class="form-control" v-bind="percent" placeholder="0,000"></money>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group bmd-form-group is-filled">
                            <label for="name" class="bmd-label-floating">Estorno (%)</label>
                            <money v-model="commission.commission_reversal" maxlength="6" class="form-control" v-bind="percent" placeholder="0,000"></money>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <input type="hidden" v-model="commission.is_visible" />
                        <!-- <button v-if="commission.is_visible" class="btn btn-success" @click.stop.prevent="addCommission(commission)">
                            <i class="fa fa-plus"></i>
                        </button>


                        <button v-else class="btn btn-warning" @click.stop.prevent="removeCommission(commission)">
                            <i class="fa fa-minus"></i>
                        </button> -->

                           <button class="btn btn-warning" @click.stop.prevent="removeCommission(commission)">
                            <i class="fa fa-minus"></i>
                        </button>
                        
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-10">
                          <button class="btn btn-success btn-block" alt="Incluir comissão" @click.stop.prevent="addCommission({})">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                    <div class="col-sm-2">&nbsp;</div>
                </div>

            </md-card-content>
        </md-card>
    </div>
</template>

<script>
    export default{
        props : {
            commissions : {
                type : Array,
                default : [],
            } 
        },
        computed : {
            typesCommissions: {
                get() {
                    return this.$store.state.commissions.typeOfCommissions
                }
            },
        },
        created() {
            this.getData();
            setTimeout(_ => {
                if(!this.commissions.length)
                    this.addCommission({});
            }, 500);
        },
        data(){
            return {
                percent: {
                    decimal: ',',
                    thousands: '',
                    prefix: '',
                    suffix: '',
                    precision: 3,
                    masked: false
                },
            };
        },
        methods : {
            getData() {
                 var self = this;
                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('commissions/typesOfcommissions');
                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            
            },

            addCommission(item){
                item.is_visible = false;
                item.administrators_id = this.$route.params.id;
                this.$emit('pushLine', { is_visible : true, administrator_id : this.$route.params.id} );
            },
            removeCommission(item){
                var self = this;
                if(item.id !== undefined)
                    self.$dialog.confirm('Somente quando o botão SALVAR for clicado que as informações nesta tela serão efetivadas. Deseja realmente remover a parcela de comissão?')
                            .then(() => { self.commissions.splice( self.commissions.indexOf(item), 1); });
                else
                {
                    self.commissions.splice( self.commissions.indexOf(item), 1);
                    self.$notify.success("Removido com sucesso!");
                }
                
            }
        }
    }
</script>